import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import * as React from "react";

import { QueryDevtools, RouterDevtools } from "~/router";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <RouterDevtools position="bottom-left" />
      <QueryDevtools position="bottom" />
    </>
  );
}
